module.exports = __webpack_public_path__ + "img/andrion.4739fac9.png";